import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type ISaveProcoreDataForProjectMutationVariables = Types.Exact<{
  procoreIntegration: Types.IProcoreIntegrationConfigurationInput
}>

export type ISaveProcoreDataForProjectMutation = {
  saveProcoreDataForProject?: boolean | null
}

export const SaveProcoreDataForProjectDocument = gql`
  mutation SaveProcoreDataForProject(
    $procoreIntegration: ProcoreIntegrationConfigurationInput!
  ) {
    saveProcoreDataForProject(procoreIntegration: $procoreIntegration)
  }
`
export type ISaveProcoreDataForProjectMutationFn = Apollo.MutationFunction<
  ISaveProcoreDataForProjectMutation,
  ISaveProcoreDataForProjectMutationVariables
>

/**
 * __useSaveProcoreDataForProjectMutation__
 *
 * To run a mutation, you first call `useSaveProcoreDataForProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProcoreDataForProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProcoreDataForProjectMutation, { data, loading, error }] = useSaveProcoreDataForProjectMutation({
 *   variables: {
 *      procoreIntegration: // value for 'procoreIntegration'
 *   },
 * });
 */
export function useSaveProcoreDataForProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveProcoreDataForProjectMutation,
    ISaveProcoreDataForProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveProcoreDataForProjectMutation,
    ISaveProcoreDataForProjectMutationVariables
  >(SaveProcoreDataForProjectDocument, options)
}
export type SaveProcoreDataForProjectMutationHookResult = ReturnType<
  typeof useSaveProcoreDataForProjectMutation
>
export type SaveProcoreDataForProjectMutationResult =
  Apollo.MutationResult<ISaveProcoreDataForProjectMutation>
export type SaveProcoreDataForProjectMutationOptions =
  Apollo.BaseMutationOptions<
    ISaveProcoreDataForProjectMutation,
    ISaveProcoreDataForProjectMutationVariables
  >
